module.exports = __webpack_public_path__ + "img/zf.58607a8c.png";